import { createBrowserHistory } from "history"
export let history = createBrowserHistory({forceRefresh:true})
//{forceRefresh:true}